import { cn } from '@/shared/utils/cn/cn.util';

import {
  SCALAR_HINT_CLASSES,
  SCALAR_HINT_PRIMARY_CLASSES,
  SCALAR_HINT_WARNING_CLASSES,
} from '../scalar.tokens';

import { type ScalarHintProps } from './ScalarHint.types';

/**
 * The line under a scalar field that says what the stored value actually is.
 *
 * This is the control's whole argument. An operator edits "15 minutes" and reads
 * "= 900 seconds"; they type a fraction and read why it cannot be stored, next
 * to the button that fixes it. Without this line these controls would only be a
 * prettier way to be wrong about the same number.
 *
 * Presentation only (U5).
 */
export function ScalarHint({ id, className, children, range, warning, action }: ScalarHintProps) {
  return (
    <p id={id} className={cn(SCALAR_HINT_CLASSES, className)}>
      {children === undefined ? null : (
        <span className={SCALAR_HINT_PRIMARY_CLASSES}>{children}</span>
      )}
      {range === undefined ? null : <span className={SCALAR_HINT_PRIMARY_CLASSES}>{range}</span>}
      {warning === undefined ? null : (
        <span className={SCALAR_HINT_WARNING_CLASSES}>{warning}</span>
      )}
      {action}
    </p>
  );
}
